var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-167.000000, -720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(0.000000, 714.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-81",
    transform: "translate(17.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-75",
    transform: "translate(150.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#5F8AEA",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-74",
    transform: "translate(11.928053, 12.251371)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-73"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-115",
    points: "4.54303262e-13 4.0268996 3.57986936 0 6.71489959 4.0268996"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.35744979,
    y1: -1.13686838e-13,
    x2: 3.35744979,
    y2: 15.6272352,
    id: "\\u8DEF\\u5F84-116"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-73\\u5907\\u4EFD",
    transform: "translate(14.571947, 8.000000) scale(1, -1) translate(-14.571947, -8.000000) translate(11.071947, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-115",
    points: "4.54303262e-13 4.0268996 3.57986936 0 6.71489959 4.0268996"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.35744979,
    y1: -1.13686838e-13,
    x2: 3.35744979,
    y2: 15.6272352,
    id: "\\u8DEF\\u5F84-116"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.b547ab55beb26323a2a2d72dc9d5d5af.svg";
export { ForwardRef as ReactComponent };